import flippboardTile from './flippboardTile.svg';
import flowerTile from './flowerTile.svg';
import parentChildReadingTile from './parentChildReadingTile.svg';
import resumeTile from './resumeTile.svg';
import talkingTile from './talkingTile.svg';
import coffeeTile from './coffeeTile.svg';
import chartTile from './chartTile.svg';
import peopleTile from './peopleTile.svg';

export const tileImages = {
  flippboardTile,
  flowerTile,
  parentChildReadingTile,
  resumeTile,
  talkingTile,
  coffeeTile,
  chartTile,
  peopleTile,
};
